import React from 'react';
import OrderSummaryItem from './OrderSummaryItem';
import { OrderSummaryItemProps } from './props';
import ExchangeRate from './ExchangeRate/ExchangeRate';

import { TEST_ID } from './tests/OrderSummaryTestIds';

import styles from './OrderSummary.module.css';
import countryCodes from '../../utils/countryCodes';

interface OrderSummaryProps {
  summaryItems: (OrderSummaryItemProps[] | React.ReactElement[])[];
  shipCountry: string;
  priceInGBP: number;
  checkoutDisclaimer: React.ReactElement;
  title: string;
}

const OrderSummary: React.FunctionComponent<OrderSummaryProps> = ({
  summaryItems,
  shipCountry,
  priceInGBP,
  checkoutDisclaimer,
  title,
}) => {
  const isOrderSummaryItem = (item: any): item is OrderSummaryItemProps => !!item.description;
  const shouldDisplayExchangeRate = shipCountry === countryCodes.GB && priceInGBP !== 0;

  return (
    <div className={styles.orderSummary}>
      <div className={styles.orderSummaryTitleWrapper}>
        <h4 className={styles.orderSummaryTitle} data-testid={TEST_ID.ORDER_SUMMARY_TITLE}>
          {title}
        </h4>
      </div>
      {summaryItems.map((i, idx) => {
        const key = idx;
        const itemsComponent = (
          <div className={styles.orderSection} key={`orderSummary-${key}`}>
            {
              i.map((item, itemIdx) => (isOrderSummaryItem(item)
                ? (
                  <OrderSummaryItem
                    description={item.description}
                    price={item.price}
                    crossedPrice={item.crossedPrice}
                    redPrice={item.redPrice}
                    fullWidthDescription={item.fullWidthDescription}
                    rowClassName={item.rowClassName}
                    key={`orderSummaryItem-${itemIdx * (idx + 1)}`}
                  />
                )
                : item))
            }
          </div>
        );

        return idx === 0
          ? itemsComponent
          : [<div className={styles.hr} key={`itemSeparator-${key}`} />, itemsComponent];
      })}
      {shouldDisplayExchangeRate && (
        <>
          <ExchangeRate priceInGBP={priceInGBP} />
          <div className={styles.hr} />
        </>
      )}
      {checkoutDisclaimer}
    </div>
  );
};

export default OrderSummary;
